import React, { useEffect } from 'react'
import { Topbar } from '@components/topbar'
import { Footer } from '@components/footer'
import { SEO } from '@components/seo'
import { useStoreActions, useStoreState } from '@stores'
import { CLIENT_CODE, SITE_URL } from '@constants'

export const ArticlePage = () => {
	const { fetchAllArticle } = useStoreActions(action => action.article)
	const { articles } = useStoreState(state => state.article)

	useEffect(() => {
		fetchAllArticle({
			page: 1,
			limit: 100,
			client_code: CLIENT_CODE
		})
	}, [fetchAllArticle])

	const breadcrumb = {
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{ '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
			{
				'@type': 'ListItem',
				position: 2,
				name: 'Articles',
				item: `${SITE_URL}/article`
			}
		]
	}

	return (
		<div className="min-h-screen bg-gray-50">
			<SEO
				title="News & Insights"
				description="Latest news, announcements, and behind-the-scenes stories from Botani Square Mall Bogor."
				path="/article"
				jsonLd={breadcrumb}
			/>
			<Topbar />

			{/* Hero Section with Banner Image */}
			<section className="relative pt-28 pb-10 sm:pt-32 sm:pb-14 overflow-hidden">
				{/* Background Banner Image */}
				<div className="absolute inset-0">
					<img
						src={require('@assets/images/banner-2.png')}
						alt="Article Banner"
						className="w-full h-full object-cover"
					/>
					{/* Overlay for better text readability */}
					<div className="absolute inset-0 bg-black bg-opacity-40"></div>
				</div>
				<div className="relative max-w-screen-xl mx-auto px-6 text-center">
					<h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-2">
						News & Insights
					</h1>
					<h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary mb-2 sm:mb-3">
						Botani Square
					</h2>
					<p className="text-sm sm:text-base text-white max-w-2xl mx-auto leading-relaxed">
						Stay informed with the latest trends, insights, and stories from the
						world of luxury retail.
					</p>
				</div>
			</section>

			{/* Article Grid Section */}
			<section className="py-16 sm:py-20 bg-gray-50">
				<div className="max-w-screen-xl mx-auto px-6">
					{articles && articles.length > 0 ? (
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
							{articles.map((article, index) => (
								<div
									key={article.id || index}
									className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
								>
									<div className="relative">
										{article.photos && article.photos.length > 0 ? (
											<img
												src={article.photos[0]}
												alt={article.name || 'Article Image'}
												className="w-full h-48 object-cover"
											/>
										) : (
											<div className="w-full h-48 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
												<div className="text-4xl">📰</div>
											</div>
										)}
										<div className="absolute top-4 left-4">
											<span className="bg-gray-100 text-gray-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
												NEWS
											</span>
										</div>
									</div>
									<div className="p-6">
										<h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2">
											{article.name || 'Article Title'}
										</h3>
										<div
											className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3"
											dangerouslySetInnerHTML={{
												__html:
													article.description || 'Article description goes here'
											}}
										/>
										<a
											href={article.redirect_url || '#'}
											className="text-primary hover:text-primary-dark font-medium text-sm transition-colors duration-200 inline-flex items-center group"
										>
											Read More...
											<svg
												className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform duration-200"
												fill="currentColor"
												viewBox="0 0 20 20"
											>
												<path
													fillRule="evenodd"
													d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
													clipRule="evenodd"
												/>
											</svg>
										</a>
									</div>
								</div>
							))}
						</div>
					) : (
						<div className="text-center py-16">
							<div className="text-6xl mb-4">📰</div>
							<h3 className="text-2xl font-bold text-gray-800 mb-4">
								No Articles Available
							</h3>
							<p className="text-gray-600 text-lg">
								Check back later for exciting news and insights!
							</p>
						</div>
					)}

					{/* Load More Button - hanya tampil jika ada articles */}
					{articles && articles.length > 0 && (
						<div className="text-center mt-8 sm:mt-12">
							<button className="bg-primary hover:bg-primary-dark text-white px-6 sm:px-8 py-3 sm:py-3 rounded-lg font-medium transition-colors duration-200">
								Load More Articles
							</button>
						</div>
					)}
				</div>
			</section>

			{/* Footer */}
			<Footer />
		</div>
	)
}
